import * as React from 'react';

export const useBootstrapPopover = <TElement extends HTMLElement>(
    buttonRef: React.RefObject<TElement | null>,
    disabled: boolean = false
) => {
    React.useEffect(() => {
        const buttonElement = buttonRef.current;
        if (!buttonElement || typeof $ === 'undefined' || typeof $.fn?.popover !== 'function') {
            return;
        }

        const popover = $(buttonElement);
        popover.popover('destroy');

        if (disabled) {
            return;
        }

        popover.popover({
            trigger: 'hover focus',
            container: 'body'
        });

        return () => {
            popover.popover('destroy');
        };
    }, [disabled]);
};

export const hidePopoverAndBlur = (buttonRef: React.RefObject<HTMLButtonElement | null>) => {
    const buttonElement = buttonRef.current;
    if (!buttonElement) {
        return;
    }

    if (typeof $ !== 'undefined' && typeof $.fn?.popover === 'function') {
        $(buttonElement).popover('hide');
    }

    buttonElement.blur();
};
